<script setup lang="ts">
import type { ProductsList } from "~/models/Content/ContentProducts"

const { price, product, showStatusDetails } = defineProps<{
  price: CrystallizeVariantPrice,
  product?: ProductsList,
  showStatusDetails: boolean
}>()

const text = computed(() => {
  if (!showStatusDetails && !price.discounted) {
    return null
  }

  if (price.discounted && price.original) {
    return [product?.productGroupStatusDetails, `Fullpris ${price.original},-`].filter(Boolean).join(" ")
  } else {
    return product?.productGroupStatusDetails
  }
})
</script>

<template>
  <p v-if="text" v-text="text" />
</template>
